import { AWIN_CLICK_REF_STORAGE_KEY } from 'constants/affiliate';
import { COOKIE_CONSENT_STORAGE_KEY } from 'constants/consent';
import { readGuardRecords, restoreGuardRecords } from 'services/onboardingGuard';

const PRESERVED_KEYS = [COOKIE_CONSENT_STORAGE_KEY, AWIN_CLICK_REF_STORAGE_KEY];

export default function clearStorageForLogout() {
  const preserved = PRESERVED_KEYS.map(key => [key, localStorage.getItem(key)]);
  const guardRecords = readGuardRecords();
  localStorage.clear();
  restoreGuardRecords(guardRecords);
  preserved.forEach(([key, value]) => {
    if (value !== null) {
      localStorage.setItem(key, value);
    }
  });
}
